const NAME_KEYS = ["surveyor_name", "username", "surveyor"];
const ID_KEYS = ["surveyor_id", "userid", "user_id"];
const NESTS = ["meta", "qa", "sr", "hierarchy", "_source", "source"];
const SUMMARY_KEYS = [
    "by_surveyor_qa",
    "by_surveyor_audio",
    "by_surveyor_hl",
    "by_piv_level2_surveyor_id_qa_status",
];

const asText = (value: unknown) => {
    if (typeof value !== "string") return "";
    const text = value.trim();
    return text;
};

const readKey = (row: any, key: string) => {
    const direct = asText(row?.[key]);
    if (direct) return direct;

    for (const nest of NESTS) {
        const nested = asText(row?.[nest]?.[key]);
        if (nested) return nested;
    }

    return "";
};

const nameFromSummary = (summary: any, surveyorId: string) => {
    if (!summary || !surveyorId) return "";

    for (const key of SUMMARY_KEYS) {
        const bucket = summary[key];
        if (!Array.isArray(bucket)) continue;

        const match = bucket.find((item) => String(item?.surveyor_id) === surveyorId);
        const name = asText(match?.surveyor_name);
        if (name) return name;
    }

    return "";
};

export const surveyorDisplayName = (row: any, summary?: any) => {
    for (const key of NAME_KEYS) {
        const name = readKey(row, key);
        if (name) return name;
    }

    const surveyorId = ID_KEYS.map((key) => readKey(row, key)).find(Boolean) || "";
    return nameFromSummary(summary, surveyorId);
};
